// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"theme_sectionTitle__k_Z27","page":"style_page__uM1QX theme_page__1oxFh","mainTitle":"style_mainTitle__2kurZ theme_sectionTitle__k_Z27"};